//const axios = require('axios').default;
import { prepareRequest } from "../../index.js";
import { setParamsToURL } from "../../index.js";
import { BANK_API_URL_LIST } from "../../routes/bank/index.js";
import store from "../../../state/store";
import axios from "axios";

async function getBankList(params, body) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token,
    },
  };
  let request = {
    method: "GET",
    url: setParamsToURL(BANK_API_URL_LIST.BANK_LIST_URL, params),
    post: body,
  };
  return prepareRequest(config, request);
}

async function getSafeDepositsList(params, body) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token,
    },
  };
  let request = {
    method: "GET",
    url: setParamsToURL(BANK_API_URL_LIST.SAFE_DEPOSITS_LIST_URL, params),
    post: body,
  };
  return prepareRequest(config, request);
}

async function getBankAccountList(params, body) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token,
    },
  };
  let request = {
    method: "GET",
    url: setParamsToURL(BANK_API_URL_LIST.BANK_ACCOUNT_LIST_URL, params),
    post: body,
  };
  return prepareRequest(config, request);
}

async function addBankAccount(params, body) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token,
    },
  };
  let request = {
    method: "POST",
    url: setParamsToURL(BANK_API_URL_LIST.BANK_ACCOUNT_ADD_URL, params),
    post: body,
  };
  return prepareRequest(config, request, true);
}

async function updateBankAccount(params, body) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token,
    },
  };
  let request = {
    method: "POST",
    url: setParamsToURL(BANK_API_URL_LIST.BANK_ACCOUNT_UPDATE_URL, params),
    post: body,
  };
  return prepareRequest(config, request, true);
}

async function deleteBankAccount(params, body) {
  let config = {
    headers: {
      Authorization: "Bearer " + store.state.auth.token,
    },
  };
  let request = {
    method: "POST",
    url: setParamsToURL(BANK_API_URL_LIST.BANK_ACCOUNT_DELETE_URL, params),
    post: body,
  };
  return prepareRequest(config, request, true);
}

async function getBankInstallmentList(params) {
  let config = {
    method: "get",
    url: `https://checkout.ofiscom.net/Banks/GetAllByBankIdInstallment/${params}`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {},
  };
  return await axios.request(config);
}

async function addBankInstallment(body) {
  let config = {
    method: "post",
    url: `https://checkout.ofiscom.net/Banks/CreateInstallment`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {
      ...body,
    },
  };
  return await axios.request(config);
}

async function updateBankInstallment(body) {
  let config = {
    method: "put",
    url: `https://checkout.ofiscom.net/Banks/UpdateInstallment`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {
      ...body,
    },
  };
  return await axios.request(config);
}

async function changeBankInstallmentActive(body) {
  let config = {
    method: "put",
    url: `https://checkout.ofiscom.net/Banks/ChangeActiveInstallment`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {
      ...body,
    },
  };
  return await axios.request(config);
}

async function deleteBankInstallment(params) {
  let config = {
    method: "delete",
    url: `https://checkout.ofiscom.net/Banks/DeleteInstallment/${params}`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
  };
  return await axios.request(config);
}

async function getBankParametersList() {
  let config = {
    method: "get",
    url: `https://checkout.ofiscom.net/Banks/GetAllActive`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {},
  };
  return await axios.request(config);
}

async function getBankParameters(params) {
  let config = {
    method: "get",
    url: `https://checkout.ofiscom.net/Banks/GetAllByBankIdParameter/${params}`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {},
  };
  return await axios.request(config);
}

async function addBankParameter(body) {
  let config = {
    method: "post",
    url: `https://checkout.ofiscom.net/Banks/CreateParameter`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {
      ...body,
    },
  };
  return await axios.request(config);
}

async function updateBankParameter(body) {
  let config = {
    method: "put",
    url: `https://checkout.ofiscom.net/Banks/UpdateParameter`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {
      ...body,
    },
  };
  return await axios.request(config);
}

async function deleteBankParameter(params) {
  let config = {
    method: "delete",
    url: `https://checkout.ofiscom.net/Banks/DeleteParameter/${params}`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
  };
  return await axios.request(config);
}

export {
  getSafeDepositsList,
  getBankList,
  getBankAccountList,
  addBankAccount,
  updateBankAccount,
  deleteBankAccount,
  getBankInstallmentList,
  addBankInstallment,
  updateBankInstallment,
  deleteBankInstallment,
  getBankParametersList,
  addBankParameter,
  updateBankParameter,
  deleteBankParameter,
  changeBankInstallmentActive,
  getBankParameters,
};
